module.exports = __webpack_public_path__ + "bootleggers-logo.jpg?25a00e0dfde74ccb43dffd9f19eb8d8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers-logo.jpg
// module id = 30
// module chunks = 0